import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { configureMetaPixel, trackMetaPixel } from "../../util/metaPixel";

export default function MetaPixelTracker() {
  const location = useLocation();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let mounted = true;
    configureMetaPixel()
      .then((configured) => {
        if (mounted) setReady(configured);
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    if (ready) trackMetaPixel("PageView");
  }, [ready, location.pathname, location.search]);

  return null;
}
